export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";

export function showError(text) {
    return function (dispatch) {
        dispatch({type: SHOW_ERROR, payload: text});
    }
}

export function hideError() {
    return function (dispatch) {
        dispatch({type: HIDE_ERROR, payload: {}});
    }
}